import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import SearchCompany from './company/CompanyComponent';
import TargetCompany from './target/TargetComponent';
import UploadCompanyInfo from './upload/UploadCompanyInfoComponent';
import MatchingCompany from './matching/MatchingCompanyComponent';
import LogOutputComponent from './logoutput/LogOutputComponent';
import UserManaged from './usermanaged/UserManagedComponent';
import ExternalData from './externaldata/ExternalDataHistoryComponent';
import CompanyRoute from '../routers/CompanyRoute';
import TargetRoute from '../routers/TargetRoute';
import UploadRoute from '../routers/UploadRoute';
import MatchingRoute from '../routers/MatchingRoute';
import LogOutputRoute from '../routers/LogOutputRoute';
import UserManagedRoute from '../routers/UserManagedRoute';
import ExternalDataRoute from '../routers/ExternalDataRoute';

class Body extends Component {
  render() {
    return (
      <Switch>
        <CompanyRoute path="/searchcompany" component={SearchCompany} />
        <TargetRoute path="/targetcompany" component={TargetCompany} />
        <UploadRoute path="/uploadcompanyinfo" component={UploadCompanyInfo} />
        <MatchingRoute path="/matchingcompany" component={MatchingCompany} />
        <LogOutputRoute path="/logoutput" component={LogOutputComponent} />
        <UserManagedRoute path="/usermanaged" component={UserManaged} />
        <ExternalDataRoute path="/externaldata" component={ExternalData} />
      </Switch>
    );
  }
}

export default Body;
